export const iconFontAwesomeTravelHotelMound = (
	<i className="fa-solid fa-mound"></i>
);
